export default function userAdminDirective() {
  return {
    template: require('./user-admin.html'),
    controller: 'UserAdminController',
    controllerAs: 'userAdminVM',
    bindToController: true,
    replace: true,
  };
}
